// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/bootstrap/dist/css/bootstrap.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/avenirnextcyr-medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "Avenir Next Cyr";
    src: local('Avenir Next Cyr'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    font-family: "Avenir Next Cyr" !important;
    --color-sidebar-pro: #004B6C;
    --color-sidebar: #00557B;
    --color-content-sidebar: #F5F5FA;
    --color-content: #FFFFFF;
    --color-main-typography: #333333;
    --color-secondary-typography: #333333;
    --color-highlighted-typography: #00557B;
    --color-sidebar-typography-disabled: #5D8EA4;
    --color-sidebar-typography-active: #FFFFFF;
    --color-camera-item: #FFFFFF;
    --color-icon-stroke: #5E5873;
    --color-content-highlight: #0095FF;
    --color-inactive-filter: #E6E7EB;
    --color-input-background: #FFFFFF;
    --color-notifiaction-background: #E73751;
    --color-item-shadow: #161D311A;
    --color-item-highlight: #0195ff;
    --color-input-border: #E6E7EB;
    --color-camera-popup: #D8D6DE;
    --color-input-wrapper: #8E99A0;
    --color-popup-header: #FFFFFF;
    --color-add-camera: #8E99A0;
    --color-addcamera-typography: #333333;
    --color-popup-content: #FFFFFF;
    --color-error-message: #E73751;
    --color-error-input-border: #E73751;
    --color-error-input-background: #fef5f6;
    --color-register-icon: #E6E7EB;
    --color-login-background: #b1b1b4;
    --color-status-green: #28C76F;
    --color-status-red: #E73751;
    --color-status-yellow:#FF9F43;


    background-color: var(--color-content);
    color: var(--color-main-typography)
}

body.dark {
    --color-sidebar-pro: #161D31;
    --color-sidebar: #21283b;
    --color-content-sidebar: #283046;
    --color-content: #161D31;
    --color-main-typography: #D0D2D6;
    --color-secondary-typography: #D0D2D6;
    --color-highlighted-typography: #D0D2D6;
    --color-sidebar-typography-disabled: #D0D2D6;
    --color-sidebar-typography-active: #FFFFFF;
    --color-camera-item: #21283B;
    --color-icon-stroke: #FFFFFF;
    --color-content-highlight: #0095FF;
    --color-inactive-filter: #181F32;
    --color-input-background: #181F32;
    --color-notifiaction-background: #E73751;
    --color-item-shadow: #181F32;
    --color-item-highlight: #0195ff;
    --color-input-border: #5E5873;
    --color-camera-popup: #D8D6DE;
    --color-input-wrapper: #8E99A0;
    --color-popup-header: #8E99A0;
    --color-add-camera: #283046;
    --color-addcamera-typography: #B4B7BD;
    --color-popup-content: #283046;
    --color-error-message: #E73751;
    --color-error-input-background: #fef5f6;
    --color-register-icon: #E6E7EB;
    --color-login-background: #b1b1b4;
    --color-status-green: #28C76F;
    --color-status-red: #E73751;
    --color-status-yellow:#FF9F43;
}
@media (prefers-color-scheme: dark) {
    body {
        --color-sidebar-pro: #161D31;
        --color-sidebar: #21283b;
        --color-content-sidebar: #283046;
        --color-content: #161D31;
    }
}

a {
    text-decoration: none
}

.content {
    margin-left: 92px;
}

@media screen and (max-width: 1000px) {
    .content {
        margin-left: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;IACI,8BAA8B;IAC9B,yFAA8F;AAClG;;AAEA;IACI,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,yCAAyC;IACzC,4BAA4B;IAC5B,wBAAwB;IACxB,gCAAgC;IAChC,wBAAwB;IACxB,gCAAgC;IAChC,qCAAqC;IACrC,uCAAuC;IACvC,4CAA4C;IAC5C,0CAA0C;IAC1C,4BAA4B;IAC5B,4BAA4B;IAC5B,kCAAkC;IAClC,gCAAgC;IAChC,iCAAiC;IACjC,wCAAwC;IACxC,8BAA8B;IAC9B,+BAA+B;IAC/B,6BAA6B;IAC7B,6BAA6B;IAC7B,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,qCAAqC;IACrC,8BAA8B;IAC9B,8BAA8B;IAC9B,mCAAmC;IACnC,uCAAuC;IACvC,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;;;IAG7B,sCAAsC;IACtC;AACJ;;AAEA;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,gCAAgC;IAChC,wBAAwB;IACxB,gCAAgC;IAChC,qCAAqC;IACrC,uCAAuC;IACvC,4CAA4C;IAC5C,0CAA0C;IAC1C,4BAA4B;IAC5B,4BAA4B;IAC5B,kCAAkC;IAClC,gCAAgC;IAChC,iCAAiC;IACjC,wCAAwC;IACxC,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,6BAA6B;IAC7B,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,qCAAqC;IACrC,8BAA8B;IAC9B,8BAA8B;IAC9B,uCAAuC;IACvC,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;AACjC;AACA;IACI;QACI,4BAA4B;QAC5B,wBAAwB;QACxB,gCAAgC;QAChC,wBAAwB;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ","sourcesContent":["@import \"~bootstrap/dist/css/bootstrap.css\";\n\n\n@font-face {\n    font-family: \"Avenir Next Cyr\";\n    src: local('Avenir Next Cyr'), url(./assets/fonts/avenirnextcyr-medium.ttf) format('truetype');\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    overflow-x: hidden;\n    font-family: \"Avenir Next Cyr\" !important;\n    --color-sidebar-pro: #004B6C;\n    --color-sidebar: #00557B;\n    --color-content-sidebar: #F5F5FA;\n    --color-content: #FFFFFF;\n    --color-main-typography: #333333;\n    --color-secondary-typography: #333333;\n    --color-highlighted-typography: #00557B;\n    --color-sidebar-typography-disabled: #5D8EA4;\n    --color-sidebar-typography-active: #FFFFFF;\n    --color-camera-item: #FFFFFF;\n    --color-icon-stroke: #5E5873;\n    --color-content-highlight: #0095FF;\n    --color-inactive-filter: #E6E7EB;\n    --color-input-background: #FFFFFF;\n    --color-notifiaction-background: #E73751;\n    --color-item-shadow: #161D311A;\n    --color-item-highlight: #0195ff;\n    --color-input-border: #E6E7EB;\n    --color-camera-popup: #D8D6DE;\n    --color-input-wrapper: #8E99A0;\n    --color-popup-header: #FFFFFF;\n    --color-add-camera: #8E99A0;\n    --color-addcamera-typography: #333333;\n    --color-popup-content: #FFFFFF;\n    --color-error-message: #E73751;\n    --color-error-input-border: #E73751;\n    --color-error-input-background: #fef5f6;\n    --color-register-icon: #E6E7EB;\n    --color-login-background: #b1b1b4;\n    --color-status-green: #28C76F;\n    --color-status-red: #E73751;\n    --color-status-yellow:#FF9F43;\n\n\n    background-color: var(--color-content);\n    color: var(--color-main-typography)\n}\n\nbody.dark {\n    --color-sidebar-pro: #161D31;\n    --color-sidebar: #21283b;\n    --color-content-sidebar: #283046;\n    --color-content: #161D31;\n    --color-main-typography: #D0D2D6;\n    --color-secondary-typography: #D0D2D6;\n    --color-highlighted-typography: #D0D2D6;\n    --color-sidebar-typography-disabled: #D0D2D6;\n    --color-sidebar-typography-active: #FFFFFF;\n    --color-camera-item: #21283B;\n    --color-icon-stroke: #FFFFFF;\n    --color-content-highlight: #0095FF;\n    --color-inactive-filter: #181F32;\n    --color-input-background: #181F32;\n    --color-notifiaction-background: #E73751;\n    --color-item-shadow: #181F32;\n    --color-item-highlight: #0195ff;\n    --color-input-border: #5E5873;\n    --color-camera-popup: #D8D6DE;\n    --color-input-wrapper: #8E99A0;\n    --color-popup-header: #8E99A0;\n    --color-add-camera: #283046;\n    --color-addcamera-typography: #B4B7BD;\n    --color-popup-content: #283046;\n    --color-error-message: #E73751;\n    --color-error-input-background: #fef5f6;\n    --color-register-icon: #E6E7EB;\n    --color-login-background: #b1b1b4;\n    --color-status-green: #28C76F;\n    --color-status-red: #E73751;\n    --color-status-yellow:#FF9F43;\n}\n@media (prefers-color-scheme: dark) {\n    body {\n        --color-sidebar-pro: #161D31;\n        --color-sidebar: #21283b;\n        --color-content-sidebar: #283046;\n        --color-content: #161D31;\n    }\n}\n\na {\n    text-decoration: none\n}\n\n.content {\n    margin-left: 92px;\n}\n\n@media screen and (max-width: 1000px) {\n    .content {\n        margin-left: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
